import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, Circle, ChevronRight } from 'lucide-react';
import { getDomainDiscoverPath } from '../../../config/routes';

interface SetupChecklistProps {
  filesTotalCount: number;
  syncStatus: string | null;
  apiKeyMasked: string | null;
  onTabChange: (tab: string) => void;
  domainId: string;
}

export const SetupChecklist: React.FC<SetupChecklistProps> = ({
  filesTotalCount,
  syncStatus,
  apiKeyMasked,
  onTabChange,
  domainId,
}) => {
  const navigate = useNavigate();
  const steps = [
    {
      label: '学習データを追加',
      completed: filesTotalCount > 0,
      onClick: () => navigate(getDomainDiscoverPath(domainId)),
      testId: 'setup-progress-step-1',
    },
    {
      label: '学習を完了',
      completed: syncStatus === 'completed' || syncStatus === 'synced',
      onClick: () => onTabChange('overview'),
      testId: 'setup-progress-step-2',
    },
    {
      label: '埋め込みコードを取得',
      completed: Boolean(apiKeyMasked),
      onClick: () => onTabChange('settings'),
      testId: 'setup-progress-step-3',
    },
  ];

  return (
    <div data-testid="setup-checklist" className="bg-white rounded-lg shadow-sm border p-6">
      <h3 className="text-base font-semibold text-text-primary mb-4">セットアップ</h3>
      {steps.map((step, i) => (
        <div
          key={i}
          data-testid={step.testId}
          className={`flex items-center gap-3 py-3 border-b last:border-b-0 cursor-pointer hover:bg-gray-50${step.completed ? ' completed' : ''}`}
          onClick={step.onClick}
        >
          {step.completed ? (
            <CheckCircle className="h-5 w-5 text-green-500" />
          ) : (
            <Circle className="h-5 w-5 text-gray-300" />
          )}
          <span className={step.completed ? 'text-sm text-text-secondary line-through' : 'text-sm text-text-primary font-medium'}>
            {step.label}
          </span>
          {!step.completed && (
            <ChevronRight className="h-4 w-4 text-gray-400 ml-auto" />
          )}
        </div>
      ))}
    </div>
  );
};
